<template>
  <ul class="opple-device-card_preview_desc">
    <li v-for="(item, index) in descList" :key="index">
      <div v-if="item.type === 1" class="opple-device-card_preview_icon">
        <img :title="item.title" class="state_img" :src="item.src">
        <em :class="item.emClass" />
      </div>
      <div v-if="item.type === 2" class="opple-device-card_preview_icon">
        <img :title="item.title" class="state_img" :src="item.src">
      </div>
      <div v-if="item.type === 3">
        <span title="tvoc" class="tvoc_state">
          {{ item.value }}
        </span>
      </div>
      <span v-if="item.text" class="opple-device-card_preview_desc_text">{{ item.text }}</span>
    </li>
  </ul>
</template>

<script>
import { DESC_FULL_CONFIG, DESC_HALF_CONFIG } from './config'
import { getdeviceImageStatus } from '@/utils/utils'

export default {
  name: 'DescList',
  components: {},
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      descList: [],
    }
  },

  computed: {},

  watch: {
    data() {
      this.initList()
    },
  },

  mounted() {
    this.initList()
  },

  methods: {
    initList() {
      
      console.log('.....descList.', this.data)
      const { data } = this
      const { StatusInfo, ChannelId, ClassSku, ChildId } = data

      try {
        const info = StatusInfo
        const descList = []

        // v-if="
        //                   model.IsTop &&
        //                     model.StatusType.toUpperCase() != '0X0000' &&
        //                     model.StatusType.toUpperCase() != '0X0100' &&
        //                     (model.StatusType.toUpperCase().substring(0, 4) !=
        //                       '0X05' || (model.StatusType.toUpperCase().substring(0, 4) ===
        //                         '0X02' && model.ChannelId !== 65535)) && msg.ClassSku.toUpperCase() != '0X001C3003'
        //                     &&
        //                     !(!$store.state.signalStrengthConfig && model.StatusType.toUpperCase() === '0X1D01')
        //                 "

        for (let i = 0; i < info.length; i++) {
          const desc = info[i]
          const statusType = desc.StatusType.toUpperCase()
          const statusTypeFour = statusType.substring(0, 4)
          const statusTypeSix = statusType.substring(0, 6)
          const childId = Number(desc.ChannelId || ChildId)
          let insertData = {}

          if (
            desc.IsTop &&
            !['0X0000', '0X0100'].includes(statusType) &&
            (statusTypeFour != '0X05' || (statusTypeFour === '0X02' && childId !== 65535)) &&
            ClassSku.toUpperCase() !== '0X001C3003' &&
            !(!this.$store.state.signalStrengthConfig && statusType === '0X1D01')
          ) {
            if (Object.keys(DESC_FULL_CONFIG).includes(statusType)) {
              const emClass = `dot${Number(desc.Value) === 1 ? ' green_dot' : ''}`

              insertData = {
                ...DESC_FULL_CONFIG[statusType],
                emClass,
              }
            }

            if (Object.keys(DESC_HALF_CONFIG).includes(statusTypeFour)) {
              const data = DESC_HALF_CONFIG[statusTypeFour]

              if (data.type === 2) {
                insertData = data
              }

              if (data.type === 3) {
                insertData = {
                  ...data,
                  value: desc.Value,
                }
              }
            }

            if (!['0X01', '0X0B', '0X14'].includes(statusTypeFour)) {
              insertData.text = `${this.cardLightInforValue(desc)}${desc.ParaUnit}`
            }
            //卡片页面也是有好多个----只是遮住了,暂时这么处理
            if(descList.length<3){
              descList.push(insertData)
            }
           
          }
        }
        this.descList = descList
      } catch (e) {
        return []
      }
    },
  },
}
</script>

<style lang="scss">
.opple-device-card_preview {
  &_desc {
    display: flex;
    line-height: 18px;
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 18px;
    }
    &_text {
      color: #0046aa;
      min-width: 50px;
      text-align: center;
      font-size: 12px;
    }
  }

  &_icon {
    height: 14px;
    img {
      height: 100%;
    }
  }
}
</style>
